import React from "react"
import FadeIn from "../general/fadein.tsx"
import FadeInTop from "../general/fadeintop.tsx"
import voicepilot from "../../images/voicepilot/voicepilot_large.png"
import voicepilotgui from "../../images/voicepilot/voicepilotgui.png"
import facedetection from "../../images/voicepilot/voicepilotfacerecognition.png"
function VoicePilot() {
    const transition = {
        transition: ".3s"
    }
    const gui_display = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Simple and intuitive GUI built with Python's customtkinter library.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={voicepilotgui}
            alt="Voice Pilot GUI"
        />
    </div>)
    const facetracking = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Face tracking capabilities to move the cursor without a mouse.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={facedetection}
            alt="Face Detection"
        />
    </div>)
    const top = (<div className="grid grid-cols-2 w-2/3 m-auto mt-5 ">
        <div className="text-center m-auto p-5 ">
            <img
                className=" h-96 w-96 rounded-full object-fill object-center"
                src={voicepilot}
                alt="Voice Pilot Logo"
            />

        </div>
        <div className="flex flex-row text-left  p-5 items-center">
            <div>
                <h1 className="text-3xl sm:text-5xl font-semibold">VoicePilot</h1>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://github.com/Datlightning/VoicePilot">GitHub</a>
                <p className="text-l sm:text-2xl">VoicePilot is a revolutionary way to interact with a Windows computer. It allows the user to navigate their computer by speaking to it. Leveraging Google's speech-to-text-api and Google's Gemini the application is able to accurately complete tasks based on the users natural language input.</p>
            </div>
        </div>
    </div>)
    return (
        <>
            <div className="divide-y divide-black/50 w-3/4 m-auto">
                <FadeInTop html={top}/>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={gui_display} left={true}/>
                    <FadeIn html={facetracking} left={false}/>
                    
                    
                </div>
            </div>
        </>
    );
}
export default VoicePilot;